import React from 'react';
import {Box, Grid, List, ListItem, Typography} from '@deere/fuel-react';
import {useStyles} from "../shared/styles/Ratings";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import {sortAlphaNum} from "../shared/utils";

export const RatingPgmPublishSubCatCardDetails = ({selectedCriteria}) => {
    const classes = useStyles();
    const listItemStyle = (index) => {
        return selectedCriteria.length - 1 === index ? {padding: '.5rem'} : {
            borderBottom: '1px solid #ccc',
            padding: '.5rem'
        }
    }

    const sortedCriteria = selectedCriteria && selectedCriteria.sort((a, b) => {
        let descA = a.description.toLowerCase(),
            descB = b.description.toLowerCase();
        return sortAlphaNum(descA, descB)
    })


    return (
        <AccordionDetails
            className={classes.accordionDetails}
            classes={{disabled: classes.disabled}}>
            <List disablePadding component="nav"
                  aria-label="sub category list"
                  className={classes.root}>
                {sortedCriteria && sortedCriteria.map((criteria, index) => {
                        return (
                            <ListItem style={listItemStyle(index)} key={index}>
                                <Grid container alignItems="center">
                                    <Grid item xs={10}>
                                        <Box display="flex" justifyContent="flex-start">
                                            <Typography variant="body1">
                                                {criteria.description}
                                                {criteria.isRequired ? (
                                                    <span style={{
                                                        marginLeft: ".25rem",
                                                        display: "inline"
                                                    }}
                                                          aria-label="required field"
                                                          className="uxf-is-required"
                                                    > * </span>
                                                ) : ""}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={1}/>
                                    <Grid item xs={1}>
                                        <Box display="flex" justifyContent="flex-start" pl={5}>
                                            <Typography variant="body1">
                                                {`${criteria.weight}%`}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </ListItem>
                        )
                    }
                )}
            </List>
        </AccordionDetails>
    )
}
